import React, { lazy, Suspense, useEffect, useState } from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import "./layout.css";

import "bootstrap/dist/css/bootstrap.min.css";
// import button from "../../assets/images/button.png";

// import NavBar from '../../component/Navbar';
// import Footer from '../footer/Footer';
// import HomePage from '../HomePage';
// import Services from '../services/Services';
// import Products from '../product/Products';
// import Team from '../team/Team';
// import Contact from '../contact/Contact';
// import Aboutus from '../about/About';
// import MultiChain from '../multi-chains/MultiChain';
// import Blogs from '../blogs/Blogs';
// import Application from '../services/Application';
// import Enterprise from '../services/Enterprise';
// import Digital from '../services/Digital';
import Home from '../home/Home';

// import Keyfeature from '../product/Keyfeature';
// import Keybenifit from '../product/Keybenifit';
// import Joinus from '../joinus/Joinus';
// import Blog1 from '../blogs/BlogDetails';
// import Terms from '../terms/Terms';
// import Privacy from '../privacy/Privacy';
// import Mohsaic from '../product/Mohsaic';
// import M1x from '../product/m1x';
// import Help from './contact';
// import Login from '../../admin/login';
// import Dashboard from '../../admin/dashboard';
// import Blog2 from '../blogs/BlogDetails1';
// import Resource from '../resource/Resource';
// import WhitePaper from '../resource/whitepaper';
// import Video from '../resource/Video';


// Lazy load route components
// const NavBar = lazy(() => import('../../component/Navbar'));
// const Footer = lazy(() => import('../footer/Footer'));
// const Services = lazy(() => import('../services/Services'));
// const Team = lazy(() => import('../team/Team'));
// const Contact = lazy(() => import('../contact/Contact'));
// const Aboutus = lazy(() => import('../about/About'));
// const MultiChain = lazy(() => import('../multi-chains/MultiChain'));
// const Blogs = lazy(() => import('../blogs/Blogs'));
// const Application = lazy(() => import('../services/Application'));
// const Enterprise = lazy(() => import('../services/Enterprise'));
// const Digital = lazy(() => import('../services/Digital'));
// const Home = lazy(() => import('../home/Home'));
// const Keyfeature = lazy(() => import('../product/Keyfeature'));
// const Keybenifit = lazy(() => import('../product/Keybenifit'));
// const Joinus = lazy(() => import('../joinus/Joinus'));
// const Blog1 = lazy(() => import('../joinus/Joinus'));
// const Terms = lazy(() => import('../terms/Terms'));
// const Privacy = lazy(() => import('../privacy/Privacy'));
// const Mohsaic = lazy(() => import('../product/Mohsaic'));
// const M1x = lazy(() => import('../product/m1x'));
// const Help = lazy(() => import('./contact'));

// import titlebar from "../../assets/images/title.png"
// import Blog3 from '../blogs/BlogDetails3';
// import M1XTokens from '../m1xToken/M1xToken';
// import Blog4 from '../blogs/BlogDetails4';
// import Disclainer from '../Disclainer/Disclainer';

const Layout = () => {

  // const [sharedData, setSharedData] = useState("");

  // const handleDataFromSender = (data: string) => {
  //   setSharedData(data);

  // };

  // const location = useLocation();


  return (


    <div className='layout'>
      <BrowserRouter>
        {/* <header>
          <div className='header-title' style={{ display: 'flex', justifyContent: 'end', background: '#fff'}}>
            <div className="header-marquee">
              <div className="marquee-text">
                Innovative interoperability bridge between Public and Private Blockchains!!! Come join and participate in our launch of our M1X Utility token!!!
              </div>
            </div>
            <img className='img-fluid' style={{ height: '25px' }} src={titlebar} alt="titlebar" />
          </div>
          <NavBar />
        </header> */}
        <section>
          {/* <Help /> */}
          <Suspense fallback={<div>Loading page...</div>} >
            <Routes>
              <Route path="/" element={<Home />} />
              {/* <Route path="/service" element={<Services />} />
              <Route path="/service/digital" element={<Digital />} />
              <Route path='/service/enterprise' element={<Enterprise />} />
              <Route path='/service/application' element={<Application />} />
              <Route path="/m1x" element={<M1x />} />
              <Route path="/mohsaic" element={<Mohsaic />} />
              <Route path="/m1x/key-benefits" element={<Keybenifit />} />
              <Route path="/m1x/key-features" element={<Keyfeature />} />
              <Route path="/team" element={<Team />} />
              <Route path="/about" element={<Aboutus />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/multi-chain" element={<MultiChain />} />
              <Route path="/m1xtoken" element={<M1XTokens />} />
              <Route path='/disclainer' element={<Disclainer />} />
              <Route path="/blogs" element={<Blogs />} />
              <Route path='/blogs/blog1' element={<Blog1 />} />
              <Route path='/blogs/blog2' element={<Blog2 />} />
              <Route path='/blogs/blog3' element={<Blog3 />} />
              <Route path='/blogs/blog4' element={<Blog4 />} />
              <Route path='/resource' element={<Resource />} />
              <Route path='/resource/whitepaper' element={<WhitePaper />} />
              <Route path='/resource/videos' element={<Video />} />

              <Route path="/joinus" element={<Joinus />} />
              <Route path='/terms' element={<Terms />} />
              <Route path="/privacy" element={<Privacy />} /> */}

              {/* Admin Panal */}
              {/* <Route path="/admin" element={<Login />} /> */}
              {/* <Route path="/admin/Dashboard" element={<Dashboard />} /> */}
              {/* 
              <Route path="/padmin" element={<PlatformAdmin />}>
              <Route index element={<PadminReport />} />
              <Route path="users" element={<PadminUsersList />} />
              <Route path="request" element={<PadminRequest />} />
              <Route path="vendors" element={<PadminVendorsList />} />
            </Route> */}
            </Routes>
          </Suspense>
        </section>
        {/* <div>
          <Footer />
        </div> */}
      </BrowserRouter>
    </div>
  );

}

export default Layout
